module.exports = __webpack_public_path__ + "static/media/weightlifting.54a52a22.svg";